import { ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";
import { LogoMark } from "@/components/LogoMark";

const IMPORTANT_LINKS = [
  {
    label: "All details of Geographical Indication",
    url: "https://ipindia.gov.in/registry",
    hint: "IP India · Registry",
  },
  {
    label: "Download GI application forms",
    url: "https://ipindia.gov.in/geographical-indications-before-you-apply-forms",
    hint: "Before-you-apply forms",
  },
  {
    label: "List of GI authorised products in India",
    url: "https://search.ipindia.gov.in/GIRPublicSearch/",
    hint: "Public search",
  },
  {
    label: "Download Journal copy (GIR)",
    url: "https://search.ipindia.gov.in/IPOJournal/Journal/GIR",
    hint: "Official journal",
  },
];

export function StoreFooter() {
  return (
    <footer className="store-footer-wrap" data-testid="store-footer">
      <section className="footer-links" data-testid="footer-important-links">
        <div className="footer-links-head">
          <span className="footer-eyebrow">GOVERNMENT OF INDIA · IP INDIA</span>
          <h3>Important links</h3>
          <p>Official sources for GI registration, application forms, authorised product listings and journal copies.</p>
        </div>
        <div className="footer-links-grid">
          {IMPORTANT_LINKS.map((l, i) => (
            <a
              key={l.url}
              href={l.url}
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link-card"
              data-testid={`footer-link-${i}`}
            >
              <span className="footer-link-hint">{l.hint}</span>
              <span className="footer-link-label">{l.label}</span>
              <span className="footer-link-cta">Open <ExternalLink size={13} /></span>
            </a>
          ))}
        </div>
      </section>
      <div className="store-footer">
        <div className="store-brand">
          <LogoMark small />
          <span>GI Bharat<small>By True Vision Welfare Society · Est. 2023</small></span>
        </div>
        <div className="store-footer-links">
          <Link to="/about" data-testid="footer-about-link">About us</Link>
          <Link to="/contact" data-testid="footer-contact-link">Contact us</Link>
          <Link to="/gi-information" data-testid="footer-gi-link">GI information</Link>
          <Link to="/return-policy" data-testid="footer-return-policy-link">Return policy</Link>
        </div>
        <span>Built around origin, trust, and opportunity.</span>
      </div>
    </footer>
  );
}
